import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import { v4 as uuidv4 } from "uuid";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { monthAdd } from "../../utils/validateExpression";

import Buttons from "./buttons";

import BasicTable from "../commons/basicTable";
import GenericBackdrop from "../commons/GenericBackdrop";
import { DataTableFormat } from "../commons/setDataTable";

export default function Transfers() {
  const [t] = useTranslation("global");
  const [data, setData] = useState([]);
  const [stores, setStores] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [filterParams, setfilterParams] = useState({});
  const [loader, setLoader] = useState(false);
  const [columnsSearch, setColumnsSearch] = useState([]);
  const [dataBackUp, setDataBackUp] = useState([]);
  const [columns, setColumns] = useState([]);
  const [datesFilter, setDatesFilter] = useState([]);
  const axiosPrivate = useAxiosPrivate();

  const condition = ["status", "merchant_id"];

  const handleLoaderOpen = () => setLoader(true);
  const handleLoaderClose = () => setLoader(false);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getBalanceDetail = (bol) => {
      handleLoaderOpen();
      axiosPrivate
        .get(
          `transactions-internal`,
          {
            params: {
              ...filterParams,
            },
          },
          {
            signal: controller.signal,
          }
        )
        .then((response) => {
          if (bol) {
            isMounted &&
              DataTableFormat(response, setColumnsSearch, setDataBackUp, setColumns, setData, setDatesFilter);
          } else {
            const today = new Date();
            setStores(response.data);
            setDatesFilter({
              dateInit: monthAdd(today, -1),
              dateEnd: today,
            });
          }
          setLoader(false);
          handleLoaderClose();
        })
        .catch((err) => {
          console.error(err);
          setLoader(false);
        });
    };
    if (is_validate()) {
      getBalanceDetail(true);
    } else if (filterParams.client_id !== undefined) {
      getBalanceDetail(false);
    } else {
      setData([]);
      setDatesFilter({
        dateInit: "",
        dateEnd: "",
      });
    }
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [isSearch, filterParams]);

  const handleCallback = (childData) => {
    setfilterParams(childData);
  };

  const is_validate = () => {
    if (isSearch) return false;
    let fill_param = 0;
    Object.keys(filterParams).forEach((p) => {
      fill_param += filterParams[p] != "" ? 1 : 0;
    });
    return fill_param > 1;
  };

  const setButtons = (results) => {
    if (results.status === "OK") {
      return (
        <Button
          data-testid="buttonOk"
          disabled
          style={{
            borderRadius: "10px",
            textTransform: "none",
            backgroundColor: "#DEF3DD",
            color: "#59C556",
            borderColor: "white",
            fontWeight: "bold",
          }}
          variant="outlined"
          startIcon={<CheckIcon />}
        >
          {t(`Insights.Transactions.Table.StatusLiquidated`)}
        </Button>
      );
    } else if (results.status === "ERROR") {
      return (
        <Button
          data-testid="buttonError"
          disabled
          style={{
            borderRadius: "10px",
            textTransform: "none",
            backgroundColor: "#EFCCD2",
            color: "#B00020",
            borderColor: "white",
            fontWeight: "bold",
          }}
          variant="outlined"
          startIcon={<CloseIcon />}
        >
          {t(`Insights.Transactions.Table.StatusError`)}
        </Button>
      );
    } else if (results.status === "REVERTED") {
      return (
        <Button
          data-testid="buttonRefunded"
          disabled
          style={{
            borderRadius: "10px",
            textTransform: "none",
            backgroundColor: "#FFEEB5",
            color: "#7D6000",
            borderColor: "white",
            fontWeight: "bold",
          }}
          variant="outlined"
          startIcon={<AttachMoneyIcon />}
        >
          {t(`Insights.Transactions.Table.StatusRefunded`)}
        </Button>
      );
    } else {
      return (
        <Button
          data-testid="buttonReversed"
          disabled
          style={{
            borderRadius: "10px",
            textTransform: "none",
            backgroundColor: "#FFEEB5",
            color: "#7D6000",
            borderColor: "white",
            fontWeight: "bold",
          }}
          variant="outlined"
          startIcon={<AttachMoneyIcon />}
        >
          {t(`Insights.Transactions.Table.StatusReversed`)}
        </Button>
      );
    }
  };

  const createaction = (row) => {
    return (
      <Fragment key={uuidv4()}>
        <TableCell align="center">{setButtons(row)}</TableCell>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <GenericBackdrop open={loader} />
      <Buttons
        data={data}
        columns={columns}
        backUp={dataBackUp}
        setSearch={setData}
        columnsSearch={columnsSearch}
        setIsSearch={setIsSearch}
        dataFilter={handleCallback}
        dateDefaultFilter={datesFilter}
        filterEmail={{ ...filterParams }}
        stores={stores}
      />
      <BasicTable dataTable={data} dataColumns={columns} action={createaction} condition={condition} />
    </Fragment>
  );
}
